import React, { useRef, useEffect } from 'react';
import { Button, Dropdown, OnChangeData } from 'carbon-components-react';
import { Earth20 } from '@carbon/icons-react';
import { OptionItem, Options, LANGUAGE } from 'types';
import PropTypes from 'prop-types';

const languageItems: Options = [
  {
    value: LANGUAGE.EN,
    label: 'EN-US'
  },
  {
    value: LANGUAGE.CN,
    label: 'CN'
  }
];

const LanguageSelector: React.FC<Props> = ({ onChange }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<any>(null);
  const onLabelBtnClick = () => dropdownRef.current.click();

  useEffect(() => {
    dropdownRef.current = containerRef.current?.querySelector(
      '.bx--dropdown button'
    );
  }, [containerRef]);

  return (
    <div className="language-selector">
      <Button
        kind="secondary"
        onClick={onLabelBtnClick}
        renderIcon={Earth20}
        iconDescription="Language"
        hasIconOnly
        tooltipPosition="bottom"
        tooltipAlignment="start"
      />
      <div className="language-selector-container" ref={containerRef}>
        <Dropdown
          id="language-selector"
          titleText=""
          label="Language"
          direction="top"
          ariaLabel="Language selector"
          initialSelectedItem={languageItems[0]}
          items={languageItems}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

const propTypes = {
  onChange: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes> & {
  onChange: ((data: OnChangeData<OptionItem>) => any) | undefined;
};

LanguageSelector.propTypes = propTypes;

LanguageSelector.defaultProps = {
  onChange: () => {}
};

export default React.memo(LanguageSelector);
